import { render } from "./messages.vue?vue&type=template&id=57b912a6&scoped=true"
const script = {}

import "./messages.vue?vue&type=style&index=0&id=57b912a6&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b912a6"]])

export default __exports__